import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['submit']

    connect() {}

    addLabResult() {
        this.submitTarget.click();
    }
}
